// src/App.tsx
import React from "react";
import { ThemeProvider, CssBaseline } from "@mui/material";
import { RouterProvider, createBrowserRouter } from "react-router-dom";
import { theme, darkTheme } from "./theme";
import { routes } from "./routes";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "./toast.css"; // We'll create this file next

// Create the router instance
const router = createBrowserRouter(routes);

export const ColorModeContext = React.createContext({
  toggleColorMode: () => {},
});

export const App: React.FC = () => {
  const [mode, setMode] = React.useState<"light" | "dark">("light");

  const colorMode = React.useMemo(
    () => ({
      toggleColorMode: () => {
        setMode((prevMode) => (prevMode === "light" ? "dark" : "light"));
      },
    }),
    []
  );

  const currentTheme = React.useMemo(
    () => (mode === "light" ? theme : darkTheme),
    [mode]
  );

  return (
    <ColorModeContext.Provider value={colorMode}>
      <ThemeProvider theme={currentTheme}>
        <CssBaseline />
        <RouterProvider router={router} />
        <ToastContainer
          position="top-right"
          autoClose={4000}
          hideProgressBar={false}
          newestOnTop
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
          theme={mode}
          limit={3}
          className="modern-toast-container"
          toastClassName="modern-toast"
          bodyClassName="modern-toast-body"
          progressClassName="modern-progress-bar"
        />
      </ThemeProvider>
    </ColorModeContext.Provider>
  );
};
